import css from './sass/style.scss';

require('./js/polyfills.js');
require('./js/fonts.js');
require('./js/init.js');
require('./js/carousels.js');
require('./js/glightbox.js');
require('./js/helpers.js');
require('./js/inview.js');
require('./js/ismobile.js');
require('./js/map.js');
require('./js/nav.js');
require('./js/offermap.js');
require('./js/validate.js');

require('./img/photos/flat.jpg');
require('./img/photos/flat@2x.jpg');
require('./img/photos/offer/big.jpg');
require('./img/photos/offer/big@2x.jpg');
require('./img/photos/offer/small.jpg');
require('./img/photos/offer/small@2x.jpg');
require('./img/photos/smallslide-1.jpg');
require('./img/photos/smallslide-1@2x.jpg');
require('./img/photos/smallslide-2.jpg');
require('./img/photos/smallslide-2@2x.jpg');
require('./img/photos/tooltip.jpg');

require('./our-locations.json');
